/* DON'T EDIT THIS FILE: edit original and run build again */ import { mapObject } from "../../framework/core/map-object.ts";
import { TenantHandler } from "../../framework/tenant-handler-type/tenant-handler.ts";
import { getAllTenantHandlers } from "./tenant.ts";

export class TenantIndexEntry {
  constructor(private tenantHandler: TenantHandler) {}

  getCode(): string {
    return this.tenantHandler.getCode();
  }

  getLabel(): string {
    return this.tenantHandler.getLabel();
  }

  publishesInMarketplace(): boolean {
    return this.tenantHandler.publishesInMarketplace();
  }

  supportsOnboardings(): boolean {
    return this.tenantHandler.supportsOnboardings();
  }

  getUserCompanyType(): string | null {
    return this.tenantHandler.getUserCompanyType();
  }

  getMavAgentId(): number | null {
    return this.tenantHandler.getMavAgentId();
  }

  getEntityId(): string {
    return this.tenantHandler.getEntityId();
  }

  getPathLabel() {
    return this.tenantHandler.getPathLabel();
  }
}

export type TenantIndex = { [tenant: string]: TenantIndexEntry };

let tenantIndex: TenantIndex | null = null;

export const fetchTenantIndex = async () => {
  if (!tenantIndex) {
    tenantIndex = {};
    for (const handler of getAllTenantHandlers()) {
      tenantIndex[handler.getCode()] = new TenantIndexEntry(handler);
    }
  }
  return tenantIndex;
};

export const getAllTenantCodes = (tenantIndex: TenantIndex): string[] =>
  Object.keys(tenantIndex);

export const getAllTenantLabels = (
  tenantIndex: TenantIndex
): { [code: string]: string } =>
  mapObject(tenantIndex, ([code, entry]) => [code, entry.getLabel()]);

export const getTenantIndexEntry = (
  tenantIndex: TenantIndex,
  tenant: string
) => {
  const entry = tenantIndex[tenant];
  if (!entry) {
    throw new Error("tenantNotFound: " + tenant);
  }
  return entry;
};

export const getTenantIndexEntryByEntityIdOrNull = (
  tenantIndex: TenantIndex,
  entityId: string
) => {
  for (const tenant in tenantIndex) {
    if (tenantIndex[tenant].getEntityId() === entityId) {
      return tenantIndex[tenant];
    }
  }
  return null;
};

export const getTenantIndexEntryByEntityId = (
  tenantIndex: TenantIndex,
  entityId: string
) => {
  const entry = getTenantIndexEntryByEntityIdOrNull(tenantIndex, entityId);
  if (!entry) {
    throw new Error("tenantEntityIdNotFound: " + entityId);
  }
  return entry;
};
